import { FC, Fragment } from "react";

import Grid from "@mui/material/Grid";

import { ImageUploaderEmptyStateAction } from "../types";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface EmptyStateProps {
  actions: ImageUploaderEmptyStateAction[];
  getActionConfig: (action: ImageUploaderEmptyStateAction) => { label: string; onClick: () => void };
  dataTest: string | undefined;
}

export const EmptyState: FC<EmptyStateProps> = ({ actions, getActionConfig, dataTest }) => {
  const { t } = useTranslate();

  return (
    <Grid container justifyContent="center" sx={{ p: 1, position: "relative" }} spacing={1}>
      <Grid item container alignItems="center" spacing={1} flexDirection="column" flexWrap="wrap">
        {actions.map((action, index) => {
          const { label, onClick } = getActionConfig(action);
          const isFirst = index === 0;
          const isFullWidth = actions.length > 1 || action.type !== "upload";
          return (
            <Fragment key={`${action.type}-${index}`}>
              {!isFirst && (
                <Grid item>
                  <DashboardTypography variant="body2" vibe="text-neutral-quiet">
                    {t("common", "or")}
                  </DashboardTypography>
                </Grid>
              )}
              <Grid item alignSelf={isFullWidth ? "stretch" : undefined}>
                <DashboardButton
                  variant={isFirst ? "tonal" : "outlined"}
                  vibe="neutral"
                  onClick={onClick}
                  fullWidth={isFullWidth}
                  data-test={isFirst ? `${dataTest}-upload-button` : undefined}
                >
                  {label}
                </DashboardButton>
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </Grid>
  );
};
